import beforeEnter from '@/modules/denuncia/views/components/DialogConsenso.js';

const routes = [
    {
        path: '/denuncias',
        name: 'denuncias',
        component: () => import('@/modules/denuncia/views/pages/index.vue'),
        props: true,
        beforeEnter,
        meta: {
            roles: ['ROLE_FEATURE_DENUNCIA']
        }
    },
    {
        path: '/denuncias/visualizar/:id',
        name: 'visualizarDenuncia',
        component: () =>
            import('@/modules/denuncia/views/pages/DenunciaDetalhe.vue'),
        props: true,
        meta: {
            roles: ['ROLE_FEATURE_DENUNCIA']
        }
    },
    {
        path: '/denuncias/inserir',
        name: 'DenunciaInserir',
        component: () =>
            import('@/modules/denuncia/views/pages/DenunciaInserir.vue'),
        props: true,
        meta: {
            roles: ['ROLE_FEATURE_DENUNCIA']
        }
    }
];

export default routes;
